<template>
  <div>
    <!-- Start Header Area -->
    <header class="header-section d-none d-xl-block">
      <div class="header-wrapper">
        <div
          id="header"
          class="header-bottom header-bottom-color--golden section-fluid sticky-header sticky-color--golden"
        >
          <div class="container" style="max-width: 95%">
            <div class="row">
              <div
                class="col-12 d-flex align-items-center justify-content-between"
              >
                <!-- Start Header Logo -->
                <div class="header-logo">
                  <div class="logo">
                    <router-link to="/"
                      ><img
                        :src="require('@/assets/ticas-logo.png')"
                        alt="logo"
                        style="max-width: 80%; margin: 20px 0"
                    /></router-link>
                  </div>
                </div>
                <!-- End Header Logo -->

                <!-- Start Header Main Menu -->
                <div
                  class="main-menu menu-color--black menu-hover-color--golden"
                >
                  <nav>
                    <ul>
                      <li>
                        <router-link to="/">Home</router-link>
                        <!-- Sub Menu -->
                      </li>

                      <li class="has-dropdown has-megaitem">
                        <a href="#">Shop <i class="fa fa-angle-down"></i></a>
                        <!-- Mega Menu -->
                        <div
                          class="mega-menu"
                          :style="
                            categories.length <= 3
                              ? 'width: 80%; min-width: 60%'
                              : 'width: 100%; min-width: 60%'
                          "
                        >
                          <ul class="mega-menu-inner">
                            <!-- Mega Menu Sub Link -->
                            <li
                              class="mega-menu-item"
                              v-for="(category, index) in categories"
                              :key="index"
                            >
                              <a href="#" class="mega-menu-item-title">{{
                                category.name
                              }}</a>
                              <ul
                                class="mega-menu-sub"
                                v-if="category.children.length > 0"
                              >
                                <li
                                  v-for="(
                                    childCategory, idx
                                  ) in category.children"
                                  :key="idx"
                                >
                                  <router-link
                                    :to="
                                      '/shop?category_id=' + childCategory.id
                                    "
                                    >{{ childCategory.name }}</router-link
                                  >
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </div>
                      </li>

                      <li>
                        <router-link to="/partnerships"
                          >Partnerships</router-link
                        >
                      </li>
                      <li>
                        <router-link to="/about-us">About Us</router-link>
                      </li>
                      <li>
                        <router-link to="/contact-us">Contact Us</router-link>
                      </li>
                      <li v-if="!authenticated">
                        <router-link to="/login">Login | Register</router-link>
                      </li>
                      <li v-else class="has-dropdown">
                        <a href="#">Account <i class="fa fa-angle-down"></i></a>
                        <!-- Sub Menu -->
                        <ul class="sub-menu">
                          <li>
                            <router-link to="/profile">Dashboard</router-link>
                          </li>
                          <li>
                            <router-link to="/profile/orders"
                              >Orders</router-link
                            >
                          </li>
                          <li>
                            <router-link to="/profile/addresses"
                              >Addresses</router-link
                            >
                          </li>
                          <li>
                            <router-link to="/profile/wedding-lists"
                              >Gift List</router-link
                            >
                          </li>

                          <li>
                            <router-link to="/profile/account-details"
                              >Account Details</router-link
                            >
                          </li>
                          <li>
                            <router-link to="/logout">logout</router-link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </nav>
                </div>
                <!-- End Header Main Menu Start -->

                <!-- Start Header Action Link -->
                <ul
                  class="header-action-link action-color--black action-hover-color--golden"
                >
                  <li>
                    <a v-b-toggle.offcanvas-wishlish class="offcanvas-toggle">
                      <i class="far fa-heart"></i>
                      <span class="item-count">{{ wishlistCount }}</span>
                    </a>
                  </li>
                  <li>
                    <a v-b-toggle.offcanvas-add-cart class="offcanvas-toggle">
                      <i class="fas fa-shopping-bag"></i>
                      <span class="item-count">{{ cartCount }}</span>
                    </a>
                  </li>
                  <li>
                    <a
                      v-b-toggle.offcanvas-weddinglist
                      class="offcanvas-toggle"
                    >
                      <i class="fa fa-gift"></i>
                      <span class="item-count">{{ weddinglistCount }}</span>
                    </a>
                  </li>
                  <!-- <li>
                    <a
                      v-b-toggle.search_sidebar
                      class="search_width offcanvas-toggle"
                    >
                      <img src="../assets/img/svg/search.svg" alt="img" />
                    </a>
                  </li> -->
                  <li>
                    <a
                      v-b-toggle.offcanvas-about
                      class="offacnvas offside-about offcanvas-toggle"
                      ><i class="fas fa-bars"></i
                    ></a>
                  </li>
                </ul>
                <!-- End Header Action Link -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <!-- Start Header Area -->

    <!-- Start Mobile Header -->

    <div
      id="mobile_header"
      class="mobile-header sticky-header sticky-color--golden mobile-header-bg-color--golden section-fluid d-lg-block d-xl-none"
    >
      <div class="container">
        <div class="row">
          <div class="col-12 d-flex align-items-center justify-content-between">
            <!-- Start Mobile Left Side -->
            <div class="mobile-header-left">
              <ul class="mobile-menu-logo">
                <li>
                  <router-link to="/">
                    <div class="logo">
                      <img
                        :src="require('@/assets/ticas-logo.png')"
                        alt="logo"
                      />
                    </div>
                  </router-link>
                </li>
              </ul>
            </div>
            <!-- End Mobile Left Side -->

            <!-- Start Mobile Right Side -->
            <div class="mobile-right-side">
              <ul
                class="header-action-link action-color--black action-hover-color--golden"
              >
                <li>
                  <a v-b-toggle.offcanvas-wishlish class="offcanvas-toggle">
                    <i class="far fa-heart"></i>
                    <span class="item-count">{{ wishlistCount }}</span>
                  </a>
                </li>
                <li>
                  <a v-b-toggle.offcanvas-add-cart class="offcanvas-toggle">
                    <i class="fas fa-shopping-bag"></i>
                    <span class="item-count">{{ cartCount }}</span>
                  </a>
                </li>
                <li>
                  <a v-b-toggle.mobile-main-menu class="offcanvas-toggle"
                    ><i class="fas fa-bars"></i
                  ></a>
                </li>
                <li>
                  <a
                    v-b-toggle.offcanvas-about
                    class="offacnvas offside-about offcanvas-toggle"
                    ><i class="fas fa-ellipsis-v"></i
                  ></a>
                </li>
              </ul>
            </div>
            <!-- End Mobile Right Side -->
          </div>
        </div>
      </div>
    </div>
    <!-- End Mobile Header -->

    <!-- ...:::: Start Mobile Main Menu Section:::... -->
    <b-sidebar
      id="mobile-main-menu"
      class="mobile-main-menu-section"
      backdrop
      right
    >
      <div class="mobile-main-menu-wrapper">
        <h4 class="offcanvas-title">Menu</h4>
        <nav class="mobile-main-nav">
          <ul class="mobile-main-menu-list">
            <li>
              <router-link to="/" @click="$bvModal.hide('mobile-main-menu')"
                >Home</router-link
              >
            </li>
            <li>
              <router-link to="/shop" @click="$bvModal.hide('mobile-main-menu')"
                >Shop</router-link
              >
            </li>
            <li>
              <router-link
                to="/partnerships"
                @click="$bvModal.hide('mobile-main-menu')"
                >Partnerships</router-link
              >
            </li>
            <li>
              <router-link
                to="/about-us"
                @click="$bvModal.hide('mobile-main-menu')"
                >About Us</router-link
              >
            </li>
            <li>
              <router-link
                to="/contact-us"
                @click="$bvModal.hide('mobile-main-menu')"
                >Contact Us</router-link
              >
            </li>
            <li v-if="!authenticated">
              <router-link
                to="/login"
                @click="$bvModal.hide('mobile-main-menu')"
                >Login | Register</router-link
              >
            </li>
            <li v-else>
              <router-link
                to="/profile"
                @click="$bvModal.hide('mobile-main-menu')"
                >Account</router-link
              >
            </li>
          </ul>
        </nav>
      </div>
    </b-sidebar>
    <!-- ...:::: End Mobile Main Menu Section:::... -->

    <!-- ...:::: Start Offcanvas Mobile Menu Section:::... -->
    <b-sidebar
      id="offcanvas-about"
      class="offcanvas-mobile-about-section"
      backdrop
      right
    >
      <!-- Start Mobile Menu Navbar Wrap -->
      <div class="mobile-menu-navbar-wrap">
        <!-- Start Mobile Menu Nav -->
        <div class="offcanvas-menu">
          <sidebar-menu :menu="menu" />
        </div>
        <!-- End Mobile Menu Nav -->
      </div>
      <!-- End Mobile Menu Navbar Wrap -->

      <!-- Start Mobile contact Info -->
      <div class="mobile-contact-info">
        <address class="address">
          <img
            :src="require('@/assets/ticas-logo-white.png')"
            alt="logo"
            style="height: 160px; width: 300px"
          />
          <!-- <span>Address: Your address goes here.</span>
          <span>Call Us: 0123456789, 0123456789</span>
          <span>Email: demo@example.com</span> -->
        </address>

        <ul class="social-link">
          <li v-if="socialLinks.facebook_link">
            <a :href="socialLinks.facebook_link" target="_blank"
              ><i class="fab fa-facebook-f"></i
            ></a>
          </li>
          <li v-if="socialLinks.twitter_link">
            <a :href="socialLinks.twitter_link" target="_blank"
              ><i class="fab fa-twitter"></i
            ></a>
          </li>
          <li v-if="socialLinks.instagram_link">
            <a :href="socialLinks.instagram_link" target="_blank"
              ><i class="fab fa-instagram"></i
            ></a>
          </li>
        </ul>

        <ul class="user-link">
          <!-- <li><router-link to="/profile/wishlist">Wishlist</router-link></li>
          <li><router-link to="/cart/">Cart</router-link></li>
          <li>
            <router-link to="/profile/checkout">Checkout</router-link>
          </li> -->
        </ul>
      </div>
      <!-- End Mobile contact Info -->
    </b-sidebar>
    <!-- ...:::: End Offcanvas Mobile Menu Section:::... -->

    <!-- Start Offcanvas Addcart Section -->
    <b-sidebar
      id="offcanvas-add-cart"
      class="offcanvas-add-cart-section"
      backdrop
      right
    >
      <div class="offcanvas-add-cart-wrapper">
        <h4 class="offcanvas-title">Shopping Cart</h4>
        <div v-if="cartCount">
          <ul class="offcanvas-cart">
            <li
              class="offcanvas-cart-item-single"
              v-for="(item, index) in cart"
              :key="index"
            >
              <div class="offcanvas-cart-item-block">
                <router-link
                  :to="{ path: '/product/' + item.id }"
                  class="offcanvas-cart-item-image-link"
                >
                  <img
                    v-if="item.image"
                    :src="item.image"
                    alt="img"
                    class="offcanvas-cart-image"
                  />
                </router-link>
                <div class="offcanvas-cart-item-content">
                  <router-link
                    :to="{ path: '/product/' + item.id }"
                    class="offcanvas-cart-item-link"
                    >{{ item.title }}</router-link
                  >
                  <div class="offcanvas-cart-item-details">
                    <span class="offcanvas-cart-item-details-quantity"
                      >{{ item.quantity }} x
                    </span>
                    <span class="offcanvas-cart-item-details-price">
                      {{
                        country == "eg" ? item.price + " EGP" : "$" + item.price
                      }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="offcanvas-cart-item-delete text-right">
                <button
                  @click="removeCartItem(item)"
                  class="offcanvas-cart-item-delete bg-transparent remove-btn"
                >
                  <i class="far fa-trash-alt"></i>
                </button>
              </div>
            </li>
          </ul>

          <div class="offcanvas-cart-total-price">
            <span class="offcanvas-cart-total-price-text">Subtotal:</span>
            <span class="offcanvas-cart-total-price-value">{{
              country == "eg" ? cartTotal + " EGP" : "$" + cartTotal
            }}</span>
          </div>

          <ul class="offcanvas-cart-action-button">
            <li>
              <router-link to="/cart" class="theme-btn-one bg-black btn_md"
                >View Cart</router-link
              >
            </li>
            <li>
              <router-link to="/checkout" class="theme-btn-one bg-black btn_md"
                >Checkout</router-link
              >
            </li>
          </ul>
        </div>

        <ul v-else class="offcanvas-cart">
          <li>Your cart is empty!</li>
        </ul>
      </div>
    </b-sidebar>
    <!-- End  Offcanvas Addcart Section -->

    <!-- Start Offcanvas Wishlist Sidebar Section -->
    <b-sidebar
      id="offcanvas-wishlish"
      class="offcanvas-add-cart-section"
      backdrop
      right
    >
      <div class="offcanvas-wishlist-wrapper">
        <h4 class="offcanvas-title">Wishlist</h4>

        <div v-if="wishlistCount">
          <ul class="offcanvas-wishlist">
            <li
              class="offcanvas-wishlist-item-single"
              v-for="(item, index) in wishlistItems"
              :key="index"
            >
              <div class="offcanvas-wishlist-item-block">
                <router-link
                  :to="{ path: '/product/' + item.product_id }"
                  class="offcanvas-wishlist-item-image-link"
                >
                  <img
                    :src="item.image"
                    alt="img"
                    class="offcanvas-wishlist-image"
                  />
                </router-link>
                <div class="offcanvas-wishlist-item-content">
                  <router-link
                    :to="{ path: '/product/' + item.id }"
                    class="offcanvas-wishlist-item-link"
                    >{{ item.name }}</router-link
                  >
                  <div class="offcanvas-wishlist-item-details">
                    <span class="offcanvas-wishlist-item-details-price">
                      {{
                        $country == "eg"
                          ? item.price + " EGP"
                          : "$" + item.price
                      }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="offcanvas-wishlist-item-delete text-right">
                <button
                  @click="removeItemFromWishlist(item.id)"
                  class="offcanvas-wishlist-item-delete bg-transparent remove-btn"
                >
                  <i class="far fa-trash-alt"></i>
                </button>
              </div>
            </li>
          </ul>
          <ul class="offcanvas-wishlist-action-button">
            <li>
              <router-link
                to="/profile/wishlist"
                class="theme-btn-one bg-black btn_md"
                >View wishlist</router-link
              >
            </li>
          </ul>
        </div>

        <ul v-else class="offcanvas-wishlist">
          <li>No Item in your wishlist!</li>
        </ul>
      </div>
    </b-sidebar>
    <!-- End Offcanvas Wishlist Sidebar Section -->

    <!-- Start Offcanvas Wishlist Sidebar Section -->
    <b-sidebar
      id="offcanvas-weddinglist"
      class="offcanvas-add-cart-section"
      backdrop
      right
    >
      <div class="offcanvas-wishlist-wrapper">
        <h4 class="offcanvas-title">Gift List</h4>

        <div v-if="weddinglistCount > 0">
          <ul class="offcanvas-wishlist">
            <li
              class="offcanvas-wishlist-item-single"
              v-for="(item, index) in weddinglistItems.items"
              :key="index"
            >
              <div class="offcanvas-wishlist-item-block">
                <router-link
                  :to="{ path: '/product/' + item.product.id }"
                  class="offcanvas-wishlist-item-image-link"
                >
                  <img
                    :src="item.product.image"
                    alt="img"
                    class="offcanvas-wishlist-image"
                  />
                </router-link>
                <div class="offcanvas-wishlist-item-content">
                  <router-link
                    :to="{ path: '/product/' + item.product.id }"
                    class="offcanvas-wishlist-item-link"
                    >{{ item.product.name }}</router-link
                  >
                  <div class="offcanvas-wishlist-item-details">
                    <span class="offcanvas-wishlist-item-details-price">
                      {{
                        $country == "eg"
                          ? (item.product.discount_price_egp > 0
                              ? item.product.discount_price_egp
                              : item.product.price_egp) + " EGP"
                          : "$" +
                            (item.product.discount_price_usd > 0
                              ? item.product.discount_price_usd
                              : item.product.price_usd)
                      }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="offcanvas-wishlist-item-delete text-right">
                <button
                  @click="removeItem(item.id)"
                  class="offcanvas-wishlist-item-delete bg-transparent remove-btn"
                >
                  <i class="far fa-trash-alt"></i>
                </button>
              </div>
            </li>
          </ul>
          <ul class="offcanvas-wishlist-action-button">
            <li>
              <router-link
                to="/profile/wedding-lists"
                class="theme-btn-one bg-black btn_md"
                >View Gift List</router-link
              >
            </li>
          </ul>
        </div>

        <ul v-else class="offcanvas-wishlist">
          <li>No Item in your gift list!</li>
        </ul>
      </div>
    </b-sidebar>
    <!-- End Offcanvas Wishlist Sidebar Section -->
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import Auth from "../Auth";
export default {
  data() {
    return {
      // Mobile Menu Item Data
      menu: [
        {
          title: "Home",
          href: "/",
        },
        {
          href: "/shop",
          title: "Shop",
        },
        {
          href: "/partnership",
          title: "Partnerships & Collaborations",
        },
        {
          href: "/about-us",
          title: "About Us",
        },
        {
          href: "/contact-us",
          title: "Contact Us",
        },
      ],
      products: [],
      category: [],
      categories: [],
      cartproduct: {},
      searchString: "",
      wishlist: [],
      authenticated: Auth.authenticated(),
      socialLinks: {},
    };
  },

  mounted: function () {
    console.log("this.$country", this.$country);
    // Menu Js
    this.$nextTick(function () {
      window.onscroll = function () {
        myFunction();
      };

      var header = document.getElementById("header");
      var mobile_header = document.getElementById("mobile_header");
      var sticky = header.offsetTop;

      function myFunction() {
        if (window.pageYOffset > sticky) {
          header.classList.add("sticky");
          mobile_header.classList.add("sticky");
        } else {
          header.classList.remove("sticky");
          mobile_header.classList.remove("sticky");
        }
      }
    });
    // Menu End
    console.log("cart", this.cart);
    // this.productsArray()
  },

  created() {
    this.getCategories();
    this.fetchCart();
    if (Auth.authenticated()) {
      this.fetchWishlist();
      this.fetchList();
    }
    this.getSocialMediaSettings();
  },

  computed: {
    ...mapState({
      productslist: (state) => state.products.productslist,
      searchItems: (state) => state.products.searchProduct,
    }),
    ...mapGetters({
      cart: "cart/cartItems",
      cartTotal: "cart/cartTotal",
      cartCount: "cart/cartCount",
      country: "country/countryCode",
      wishlistCount: "wishlist/wishlistCount",
      wishlistItems: "wishlist/wishlistItems",
      weddinglistCount: "weddingList/weddinglistCount",
      weddinglistItems: "weddingList/weddingList",
    }),
  },

  methods: {
    ...mapActions("cart", ["fetchCart"]),
    ...mapActions("wishlist", ["fetchWishlist", "removeFromWishlist"]),
    ...mapActions("weddingList", ["fetchList", "removeItem"]),

    discountedPrice(item) {
      return (item.price - item.price * (item.discount / 100)).toFixed(2);
    },

    removeItemFromWishlist(itemId) {
      this.$swal
        .fire({
          title: "Do you want to Delete this item from Wishlist?",
          showCancelButton: true,
          confirmButtonText: "Delete",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#6d6f71",
        })
        .then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.removeFromWishlist(itemId);
          }
        });
    },

    // For Delete/Remove Product Item
    removeCartItem: function (product) {
      this.$swal
        .fire({
          title: "Do you want to Delete this item?",
          showCancelButton: true,
          confirmButtonText: "Delete",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#6d6f71",
        })
        .then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.$store.dispatch("cart/removeItem", product);
          }
        });
    },
    searchProduct() {
      this.$store.dispatch("products/searchProduct", this.searchString);
    },
    getCategories() {
      this.$http.get("categories/parents").then((res) => {
        this.categories = res.data.data;
      });
    },
    getSocialMediaSettings() {
      this.$http.get("settings/footer").then((res) => {
        this.socialLinks = res.data.data.settings;
      });
    },

    openWeddingList() {
      if (Auth.authenticated()) {
        this.$router.push("/profile/wedding-lists");
      } else {
        this.$swal
          .fire({
            title: "Please login to access your gift list",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Login",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#6d6f71",
            cancelButtonColor: "#d33",
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.$router.push("/login");
            }
          });
      }
    },
  },
};
</script>

<style>
/* Mobile Menu Multi Dropdown Items Start */
.v-sidebar-menu .vsm--toggle-btn {
  display: none;
}
.v-sidebar-menu {
  position: relative;
  background-color: transparent;
}
.v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 {
  background-color: var(--main-theme-color);
}
.v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active,
.v-sidebar-menu .vsm--link_level-1.vsm--link_active {
  -webkit-box-shadow: 3px 0px 0px 0px var(--main-theme-color) inset;
  box-shadow: 3px 0px 0px 0px var(--main-theme-color) inset;
}
/* Mobile Menu Multi Dropdown Items End */

/* Mobile Main Menu Styles */
.mobile-main-menu-wrapper {
  padding: 20px;
}
.mobile-main-menu-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.mobile-main-menu-list li {
  border-bottom: 1px solid #eee;
}
.mobile-main-menu-list li a {
  display: block;
  padding: 15px 0;
  color: #333;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
}
.mobile-main-menu-list li a:hover {
  color: #d4af37;
}
</style>
